<template>
  <v-app light>
    <v-navigation-drawer
      persistent
      v-model="drawer"
      enable-resize-watcher
      app
    >
      <navigation-menu></navigation-menu>
    </v-navigation-drawer>
    <v-toolbar fixed light app>
      <v-toolbar-side-icon @click.native.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>GeoConverter</v-toolbar-title>
      <v-spacer></v-spacer>
      <img height="48" class="logo" src="./assets/img/logos/OST-Logo_DE.png" alt="Ostschweizer Fachhochschule (OST) Logo">
    </v-toolbar>
    <main>
      <v-content>
        <v-container fluid grid-list-lg>
          <transition name="fade-transition" mode="out-in">
            <router-view></router-view>
          </transition>
        </v-container>
      </v-content>
    </main>
    <v-footer fixed app>
      <span>A service provided by <router-link to="about-us">Geometa Lab at IFS OST</router-link></span>
      <v-spacer></v-spacer>
      <queue-stats
        :small="true"
        queueName="default"
      ></queue-stats>
    </v-footer>
  </v-app>
</template>

<script>
  import NavigationMenu from '@/components/Menu';
  import QueueStats from '@/components/QueueStats';

  export default {
    data() {
      return {
        drawer: true,
      };
    },
    components: {
      'navigation-menu': NavigationMenu,
      'queue-stats': QueueStats,
    },
  };
</script>

<style lang="stylus">
  @import './stylus/main'

  .full-width {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue